<template>
  <div>
    <div v-if="planList.length > 1" style="padding: 20px 0">
      <el-button
          v-for="(plan,idx) in planList" :key="plan.id"
          :type="plan.id===activeTroubleId?'primary':undefined"
          @click="activeTroubleId=plan.id"
      >定损方案{{ idx + 1 }}
        <span v-if="plan.is_effective">（当前生效）</span>
      </el-button>
    </div>
    <template v-for="(plan) in planList" :key="plan.id">
      <div v-if="plan.id===activeTroubleId" class="plan-item">
        <div v-for="(item,index) in plan.trouble_list" :key="item.trouble_id" class="trouble-item">
          <div class="title">
            <span>{{ '定损故障' + (index + 1) }}</span>
          </div>
          <FrameForm
              readonly
              component-param="station_identify_trouble"
              :init-ds-only="true"
              :init-data="item"/>
          <div v-if="showIdentifyPrice" style="display: flex;">
            <div style="width: 135px;text-align: right;line-height:32px;padding-right: 12px;height: 32px;">维修服务费</div>
            <div style="line-height: 32px;">{{item.service_level_price}}</div>
          </div>
          <div v-if="showIdentifyPrice" style="display: flex">
            <div style="width: 135px;text-align: right;line-height:32px;padding-right: 12px;height: 32px;">物料价格</div>
          <KfInputTable style="padding-right: 10px;width: calc(100% - 130px)" component-id="material_price_detail_table"
                        :init-ds-only="true"
                        :model-value="item.material_price_list" :form-readonly="true" ></KfInputTable>
          </div>
        </div>
      </div>
    </template>

    <div v-if="showSupplementMaterial">
      <div v-for="item in supplementMaterialList" class="trouble-item" :key="item.id">
        <div class="title">
          <span>{{ '补料编号：' + item.id }}</span>
        </div>
        <FrameForm component-param="bu_supplement_material" :init-data="item" />
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "BuIdentifyPlan",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeTroubleId: '',
      planList: [],
      showIdentifyPrice: false,
      supplementMaterialList:[],
      showSupplementMaterial:false
    }
  },
  async created() {
    await this.getIdentifyPlan();
    await this.getShowIdentifyPrice();
    await this.getSupplementMaterial();

  },

  methods: {
    async getIdentifyPlan(){
      let data = await this.$http('buCsTaskService.getIdentifyPlan', {
        item_id: this.parentData.item_id
      });
      this.planList = data || []
      if (this.planList.length > 0) {
        this.activeTroubleId = this.planList[this.planList.length - 1].id
      } else {
        this.activeTroubleId = ''
      }
    },
    async getShowIdentifyPrice() {
      let data = await this.$http('buCsTaskService.getShowIdentifyPrice', {
        item_id: this.parentData.item_id
      });
      if(data){
        this.showIdentifyPrice = data.showIdentifyPrice
      }
    },
    //获取补料数据
    async getSupplementMaterial() {
      let data = await this.$http('buItemStationService.getSupplementMaterial', {item_id: this.parentData.item_id,});
      if(data){
        this.supplementMaterialList = data.supplementMaterialList;
        this.showSupplementMaterial = data.showSupplementMaterial;
      }
    },
  },

}
</script>


<style scoped lang="less">

.trouble-form {
  padding: 10px 0 0 0;
  width: 700px;
}

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}


</style>